import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import notificationService from '../services/notification.service';
import { useAuth } from '../context/UseAuth';

export const useNotifications = () => {
  const queryClient = useQueryClient();
  const { isAuthenticated } = useAuth();

  // --- INICIO DE LA MODIFICACIÓN ---
  // Volvemos a un useQuery simple. Solo nos interesa la primera página para el panel.
  const { data, isLoading } = useQuery({
    queryKey: ['notifications'],
    // Pedimos explícitamente la página 1.
    queryFn: () => notificationService.getNotifications(1),
    enabled: !!isAuthenticated,
    refetchInterval: 60000, // Mantenemos el refresco automático
    refetchOnWindowFocus: true,
  });
  // --- FIN DE LA MODIFICACIÓN ---

  const markAsReadMutation = useMutation({
    mutationFn: notificationService.markAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });

  const handleMarkAsRead = () => {
    // La lógica de marcar como leído no cambia.
    if (data?.unreadCount > 0) {
      markAsReadMutation.mutate();
    }
  };

  return {
    isLoading,
    // Devolvemos directamente las notificaciones de la primera página.
    notifications: data?.notifications || [],
    unreadCount: data?.unreadCount || 0,
    markAsRead: handleMarkAsRead,
    // Ya no necesitamos las funciones de paginación infinita aquí.
  };
};
